import { z } from "zod/v4";

export const getFulfillmentOrdersByOrder = {
  name: "getFulfillmentOrdersByOrder" as const,
  input: z.object({ orderId: z.string() }),
  output: z.any(),
};
